var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeaturesAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 35,
    viewBox: "0 0 33 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6751 6.62571C22.6504 -0.468632 11.8198 1.71436 8.28003 6.43934C4.74023 11.1643 14.6518 14.1466 18.249 21.5132C23.1001 31.4477 36.2061 15.4936 28.6751 6.62571Z",
    fill: "#001F4B",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 29.8667C15.7111 29.8667 15.4333 29.8111 15.1667 29.7C14.9 29.5889 14.6667 29.4111 14.4667 29.1667L3.50001 16C3.25557 15.6889 3.11112 15.3389 3.06668 14.95C3.02223 14.5611 3.0889 14.1889 3.26668 13.8333L6.10001 8.1C6.27779 7.76667 6.52779 7.5 6.85001 7.3C7.17223 7.1 7.52223 7 7.90001 7H24.1C24.4778 7 24.8278 7.1 25.15 7.3C25.4722 7.5 25.7222 7.76667 25.9 8.1L28.7333 13.8333C28.9111 14.1889 28.9778 14.5611 28.9333 14.95C28.8889 15.3389 28.7445 15.6889 28.5 16L17.5333 29.1667C17.3333 29.4111 17.1 29.5889 16.8333 29.7C16.5667 29.8111 16.2889 29.8667 16 29.8667ZM11.9333 14H20.0667L17.5667 9H14.4333L11.9333 14ZM15 26.7V16H6.10001L15 26.7ZM17 26.7L25.9 16H17V26.7ZM22.3 14H26.5L23.9667 9H19.8L22.3 14ZM5.50001 14H9.70001L12.2 9H8.03335L5.50001 14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesAsset);
export default __webpack_public_path__ + "static/media/features-asset.97de7c5b.svg";
export { ForwardRef as ReactComponent };